import axios, { AxiosRequestConfig } from 'axios'

const getBackendBaseUrl = (): string => {
  const currentFrontendUrl = window.location.href

  if (currentFrontendUrl.includes('localhost') || currentFrontendUrl.includes('127.0.0.1')) {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:3007'
  }

  if (currentFrontendUrl.includes('.petso.fr')) {
    return 'https://petso-backend.herokuapp.com'
  }

  return 'https://petso-backend.herokuapp.com'
}

export const backendClient = axios.create({
  baseURL: `${getBackendBaseUrl()}/v1`,
})

const isPublicRequest = (config: AxiosRequestConfig): boolean => {
  const normalizedUrl = config.url?.replace(/^\/v1/, '') || ''
  const method = (config.method || 'get').toUpperCase()

  return (
    (method === 'POST' &&
      (normalizedUrl === '/login' ||
        normalizedUrl === '/admin-login' ||
        normalizedUrl === '/customers' ||
        normalizedUrl === '/password-reset' ||
        normalizedUrl === '/password-reset/request')) ||
    normalizedUrl.includes('/adopters-platform/auth')
  )
}

backendClient.interceptors.request.use((config) => {
  if (isPublicRequest(config)) {
    if (config.headers) {
      delete config.headers.Authorization
    }

    return config
  }

  const token = localStorage.getItem('token')
  if (!token) {
    if (config.headers) {
      delete config.headers.Authorization
    }

    return config
  }

  config.headers = config.headers ?? {}
  config.headers.Authorization = `Bearer ${token}`

  return config
})
